












import Vue from 'vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import Fetch from '@/lib/fetch.ts';
import {Weather} from '@/lib/types';
import { Route } from 'vue-router';

export default Vue.extend({
    data() {
        return {
            loaded: false,
            weatherData: {} as Weather,
            icon: 'unknown',
        };
    },
    components: {
        LoadingSpinner,
    },
    beforeRouteEnter(to: Route, from: Route, next: any) {
        next(async (vm: any) => {
            vm.weatherData = await Fetch.get('/api/weather');
            vm.resolveIcon();
        });
    },
    methods: {
        resolveIcon() {
            const isNight = () => {
                const now = new Date();
                const sunrise = this.weatherData.sunrise * 1000;
                const sunset = this.weatherData.sunset * 1000;
                return new Date(sunrise) > now || new Date(sunset) < now;
            };
            switch (this.weatherData.description) {
                case ('clear sky'):
                    if (isNight()) {
                        this.icon = 'moon-stars';
                    } else {
                        this.icon = 'sun';
                    }
                    break;
                case ('light snow'):
                    this.icon = 'light-snow';
                    break;
                case ('light intensity shower rain'):
                case ('light rain'):
                    this.icon = 'light-rain';
                    break;
                case ('haze'):
                    this.icon = 'haze';
                    break;
                case ('broken clouds'):
                case ('overcast clouds'):
                    this.icon = 'clouds';
                    break;
                case ('scattered clouds'):
                case ('few clouds'):
                    if (isNight()) {
                        this.icon = 'clouds-night';
                    } else {
                        this.icon = 'partly-cloudy';
                    }
                    break;
                case ('mist'):
                    this.icon = 'moisture';
                    break;
                default:
                    this.icon = 'unknown';
                    break;
            }
            this.loaded = true;
        },
    },
});
